// push with signed commit to release
// git commit -S -m "your commit message"
import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import axios from "axios";
import "./App.css";
import "./loading.css";

import Home from "./content/pages/Home";
import Footer from "./content/pages/Footer";
import NavbarTop from "./components/NavbarTop";
import Login from "./components/Login";
import Category from "./content/pages/Category.js";
import SingleTitle from "./content/pages/SingleTitle";
import SearchTitles from "./content/pages/SearchTitles";
import CreateTitle from "./content/pages/CreateTitle";
//-------------------------------------------------
import {
  name as appName,
  suffix as appSuffix,
  version as appVer,
} from "../package.json";

const APPDATA = {
  TITLE: appName || "App Name Not Set",
  NAME:
    appName
      .replace(/-/g, " ")
      .replace(/(^\w{1})|(\s+\w{1})/g, (chr) => chr.toUpperCase()) || "",
  PROJECT:
    appName.replace(/-/g, " ").toUpperCase() + ` (${appSuffix})` ||
    "Project Not Set",
  VER: appVer || "Version Not Set",
  HOME: "/",
  //---------------------------------------
  TITLEIMG: process.env.REACT_APP_IMG_TITLE,
  FOOTERIMG: process.env.REACT_APP_IMG_FOOTER,
  BACKEND: process.env.REACT_APP_BACKEND || "LocalHost:5000?",
  FRONTEND:
    process.env.REACT_APP_FRONTEND ||
    (process.env.HOST || "LocalHost") + ":" + (process.env.PORT || "3000"),
  DEVLEAD: process.env.REACT_APP_DEV_LEAD || "Victor Wright",
  DEVTEAM: process.env.REACT_APP_DEV_TEAM || "-hidden-",
  EMAIL: process.env.REACT_APP_DEV_EMAIL || "victor.wright@outlook.de",
  PHONE: process.env.REACT_APP_DEV_PHONE || "-hidden-",
  LOCATION: process.env.REACT_APP_DEV_ADDR || "-hidden-",
  FLIGHT: process.env.REACT_APP_PROJECT_FLIGHT || "-pre-flight-",
  INFO: process.env.REACT_APP_PROJECT_INFO || "-still under development-",
};
document.title = "Welcome to " + APPDATA.NAME;
//-------------------------------------------------
// const BACKEND = process.env.REACT_APP_BACKEND;

function App() {
  const [currentUser, setCurrentUser] = useState("");
  const [searchQry, setSearchQry] = useState("");
  const [categories, setCategories] = useState(["Lunch"]);
  const [loading, setLoading] = useState("");

  useEffect(() => {}, [loading]); //        to re-render when any loading event occurs

  useEffect(() => {
    setLoading("Loading ...");
    setCurrentUser(sessionStorage.getItem("currentUser"));
    (async () => {
      try {
        sessionStorage.setItem("APPDATA", APPDATA);
        const results = await axios.get(`${APPDATA.BACKEND}/api/categories/`);
        setCategories(results.data.tuples);
        setLoading("");
      } catch (error) {
        setLoading(error.message);
      }
    })();
    return () => {
      sessionStorage.clear();
      localStorage.clear();
    };
  }, []);

  const handleSearchClick = (e) => {
    e.preventDefault();
    if (e.target.form[0].value !== "") {
      setSearchQry(e.target.form[0].value);
      e.target.form[0].value = "";
    } else {
      alert("Please enter something in search");
    }
  };

  const handleClearQry = () => setSearchQry("");

  return (
    <>
      <NavbarTop
        APPDATA={APPDATA}
        handleSearchClick={handleSearchClick}
        handleClearQry={handleClearQry}
        categories={categories}
        currentUser={currentUser}
      />
      {loading ? (
        <>
          <div className="loading_container">
            <div className="loading"></div>
            <h4>{loading}</h4>
          </div>
        </>
      ) : (
        <>
          {searchQry ? (
            <SearchTitles
              searchQry={searchQry}
              handleClearQry={handleClearQry}
              BACKEND={APPDATA.BACKEND}
            />
          ) : (
            <Routes>
              <Route
                path="/"
                exact
                element={
                  <Home
                    loading={loading}
                    categories={categories}
                    APPDATA={APPDATA}
                  />
                }
              />
              <Route
                exact
                path="/login"
                element={
                  <Login
                    setCurrentUser={setCurrentUser}
                    BACKEND={APPDATA.BACKEND}
                  />
                }
              />
              {currentUser ? (
                <>
                  <Route
                    exact
                    path="/newtitle"
                    element={
                      <CreateTitle
                        currentUser={currentUser}
                        categories={categories}
                        BACKEND={APPDATA.BACKEND}
                      />
                    }
                  />
                </>
              ) : null}
              <Route
                exact
                path="/categories/:category"
                element={
                  <Category categories={categories} BACKEND={APPDATA.BACKEND} />
                }
              />
              <Route
                exact
                path="/recipes/:id" //                          TODO: change recipes route to "entry"
                element={
                  <SingleTitle
                    categories={categories}
                    BACKEND={APPDATA.BACKEND}
                  />
                }
              />
            </Routes>
          )}
          <div>
            <Footer APPDATA={APPDATA} />
          </div>
        </>
      )}
    </>
  );
}

export default App;
